export default "__VITE_ASSET__BeeBjKkm__"